import {
  FETCH_UNIT_INIT_ACTION,
  FETCH_UNIT_SUCCESS_ACTION,
  FETCH_UNIT_FAIL_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_UNIT_SUCCESS_ACTION:
      return {
        ...state,
        UnitList: action.payload.rows,
        UnitCount: action.payload.count
      };
    default:
      return {
        ...state
      };
  }
}
